<script>
	import { onMount } from "svelte";
	import SveltyPicker from "svelty-picker";
	import queryString from "query-string";

	export let value;
	export let isRange = false;
	export let onChange = () => {};
	export let name;
	export let placeholder = "Select a date range";
	export let disabledDates = () => false;

	let ignoreBlurEvent = false;

	function handleChange(e) {
		if (ignoreBlurEvent) {
			ignoreBlurEvent = false;
			return;
		}
		value = e.detail;
		onChange(e);
	}

	function handleBlur() {
		ignoreBlurEvent = true;
	}
</script>

<SveltyPicker
	{value}
	inputClasses="form-control getgo input calendar-icon"
	format="yyyy-mm-dd"
	{isRange}
	on:change={(e) => handleChange(e)}
	on:blur={handleBlur}
	{name}
	{placeholder}
	autocommit={true}
	clearBtn={false}
	todayBtnClasses={"btn fds-button primary"}
	disableDatesFn={disabledDates}
/>

<style>
	:global(.calendar-icon) {
		background-image: url("/assets/calendar.svg") !important;
		background-repeat: no-repeat !important;
		background-position: left calc(0.375em + 0.1875rem) center !important;
		background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
		padding-left: 35px !important;
	}

	:global(.form-control.getgo.input::placeholder) {
		color: var(--fds-on-surface-variant) !important;
	}
</style>
